module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cbc57fb42f120b648895bb45f239e189.gif";